import React, { useEffect, useRef } from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./Datepicker.scss";

import { ReactComponent as CloseIcon } from "static/icons/close-or.svg";
function handleConditionalFullScreenRendering() {
  const fsElem = document.fullscreenElement;
    const rootPortalElem = document.getElementById("root-portal");

    if (rootPortalElem) {
      // for when its not fullscreen
      document.body.appendChild(rootPortalElem);
    }

    if (fsElem && rootPortalElem) {
      fsElem.appendChild(rootPortalElem);
    }
}

const DatePicker = ({
  onChangeValue,
  value,
  onSetValue,
  clearValue,
  isEditable,
  isOpen,
  dateFormat = "yyyy/MM/dd",
  placeholderText = "YYYY/MM/DD",
  inputClassName = "date_input",
  popperClassName = "date_calendar",
  wrapperClassName = "date-picker-wrapper",
  ...props
}) => {
  const currentDateValue = (typeof value === 'string' || value instanceof Date) && !isNaN(new Date(value).getTime()) ? new Date(value) : null;

  const clearButtonRef = useRef(null);
  const wasClickInsideClearButton = useRef(false);

  useEffect(() => {
    const handleMouseDown = (event) => {
      if (clearButtonRef.current && clearButtonRef.current.contains(event.target)) {
        wasClickInsideClearButton.current = true;
      }
    };

    document.addEventListener("mousedown", handleMouseDown);

    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
    };
  }, []);


    useEffect(() => {
    document.addEventListener("fullscreenchange", handleConditionalFullScreenRendering);

    handleConditionalFullScreenRendering();

    return () => {
      document.removeEventListener("fullscreenchange", handleConditionalFullScreenRendering);
    };
  }, []);

  
  const handleSetValue = () => {
    if (!onSetValue) return;
    if (wasClickInsideClearButton.current) {
      wasClickInsideClearButton.current = false;
      return;
    }
    onSetValue();
  };

  const open = typeof isOpen === "boolean" ? isOpen : isEditable;

  return (
    <div className={wrapperClassName} onClick={handleConditionalFullScreenRendering} >
      <ReactDatePicker
        open={open}
        portalId="root-portal"
        className={inputClassName}
        popperClassName={popperClassName}
        monthClassName="date_title"
        selected={currentDateValue}
        placeholderText={placeholderText}
        dateFormat={dateFormat}
        autoFocus={false}
        onChange={onChangeValue}
        onBlur={handleSetValue}
        onCalendarClose={handleSetValue}
        {...props}
      />
      {clearValue &&
        <div
          className="clear-button"
          ref={clearButtonRef}
          onClick={(e) => clearValue(e)}
        >
          <CloseIcon />
        </div>
      }
    </div>
  );
};

export default DatePicker;